import { useCallback, useState } from 'preact/hooks';
import { useT } from './i18n';

export interface Example {
  id: string;
  url: string;
  label: string;
}

export const EXAMPLES: Example[] = [
  { id: 'snow-leopard', url: 'examples/snow-leopard.webp', label: 'Snow leopard' },
  { id: 'dragon-girl', url: 'examples/dragon-girl.webp', label: 'Dragon girl' },
  { id: 'horse-girl', url: 'examples/horse-girl.webp', label: 'Horse girl' },
  { id: 'house', url: 'examples/house.webp', label: 'House' },
];

interface Props {
  onFile: (blob: Blob, name: string) => void;
  /** opens the file picker owned by the App */
  onPick: () => void;
  /** global drag-over state, driven by the App */
  dragging: boolean;
}

export function Dropzone({ onFile, onPick, dragging }: Props) {
  const t = useT();
  const [loadingExample, setLoadingExample] = useState<string | null>(null);

  const pickExample = useCallback(
    async (ex: Example) => {
      setLoadingExample(ex.id);
      try {
        const res = await fetch(ex.url);
        if (!res.ok) throw new Error(`failed to fetch ${ex.url}`);
        const blob = await res.blob();
        onFile(blob, `${ex.id}.webp`);
      } finally {
        setLoadingExample(null);
      }
    },
    [onFile],
  );

  return (
    <div class={`dropzone${dragging ? ' dragging' : ''}`}>
      <h2>{t('drop.title')}</h2>
      <p style={{ margin: 0, fontSize: 12.5 }}>{t('drop.hint')}</p>
      <button class="primary" onClick={onPick}>
        {t('action.upload')}
      </button>
      <div style={{ marginTop: 8, fontSize: 12, color: 'var(--text-faint)' }}>
        {t('drop.examples')}
      </div>
      <div class="examples">
        {EXAMPLES.map((ex) => (
          <button
            key={ex.id}
            class="example"
            disabled={loadingExample !== null}
            onClick={() => void pickExample(ex)}
          >
            <img src={ex.url} alt={ex.label} loading="lazy" />
            <span>{loadingExample === ex.id ? '…' : ex.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
